export default "__VITE_ASSET__9a502177__"